

export class AlertGroupStatusInput implements IAlertGroupStatusInput {
    /** The auto-generated id of the alert group master */
    alertGroupId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IAlertGroupStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.alertGroupId = _data["alertGroupId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): AlertGroupStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new AlertGroupStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["alertGroupId"] = this.alertGroupId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IAlertGroupStatusInput {
    /** The auto-generated id of the alert group master */
    alertGroupId: number;
    /** The updated status */
    status: number;
}

